import PermissionPolicyChecker, { TRole } from "class/permissionPolicyChecker";
import { useRecoilValue } from "recoil";
import { userRole } from "recoil/recoilState";
export const getRole = (role: number): TRole => {
  switch (role) {
    case 0:
      return "Owner";
    case 1:
      return "Super Admin";
    case 2:
      return "Policy Admin";
    case 3:
      return "Security Admin";
    default:
      return "Staff";
  }
};
const usePermissionPolicy = () => {
  const user_role = useRecoilValue(userRole);
  const recoilRole = { role: user_role.role };
  const role = getRole(recoilRole.role ? recoilRole.role : 0);

  const UserPermissionPolicyChecker = PermissionPolicyChecker.getInstance(role);

  return UserPermissionPolicyChecker;
};

export default usePermissionPolicy;
